//import statement
import { useEffect, useState, useTransition } from "react";
import {
  Button,
  ButtonGroup,
  Col,
  Container,
  Row,
  Spinner,
} from "react-bootstrap";
import Header from "../reuseable/header";
import Footer from "../reuseable/footer";
import RaffleCard from "../reuseable/raffleCard";
import PageName from "../reuseable/pageName";
import useRaffles from "../hooks/useRaffles";

//functional component
const Raffles = () => {
  const { raffles } = useRaffles();
  const [raffleSelector, setRaffleSelector] = useState(true);
  const [rafflesToShow, setRaffleToShow] = useState([]);
  const [isPending, startTransition] = useTransition();

  useEffect(() => {
    if (!raffles) {
      return;
    }
    startTransition(() => {
      setRaffleToShow(
        raffleSelector
          ? raffles.filter((raffle) => !raffle.isClosed)
          : raffles.filter((raffle) => raffle.isClosed)
      );
    });
  }, [raffles, raffleSelector]);

  return (
    <div className="raffle-page bg-dark">
      <Container>
        <Header />
        <PageName
          name="RAFFLES"
          raffleSelector={raffleSelector}
          setRaffleSelector={setRaffleSelector}
        />
        <Row>
          <Col md="12" className="text-center">
            <ButtonGroup className="mb-2 buttons_wrapper">
              <Button
                onClick={() => setRaffleSelector(true)}
                className={`${raffleSelector && "active"}`}
              >
                LIVE
              </Button>
              <Button
                onClick={() => setRaffleSelector(false)}
                className={`${!raffleSelector && "active"}`}
              >
                CLOSED
              </Button>
            </ButtonGroup>
          </Col>
        </Row>
        <Row>
          {isPending ? (
            <div className="bg-spinner">
              <Spinner animation="grow" role="status" variant="light" />
            </div>
          ) : rafflesToShow.length > 0 ? (
            rafflesToShow.map((raffle, index) => {
              return <RaffleCard raffle={raffle} key={index} />;
            })
          ) : (
            <div className="d-flex justify-content-center align-items-center my-5">
              <h1 className="not_found my-5">No Raffles Found</h1>
            </div>
          )}
        </Row>
        <Footer />
      </Container>
    </div>
  );
};
export default Raffles;
